import { useGraphqlMutation, useTranslation } from "@mzara/component";
import { TAppointment } from "@mzara/graphql";

export const useAppointmentMutation = () => {
    const t = useTranslation()
    return useGraphqlMutation<TAppointment>(gql, { showLoadingMessage: true, loadingMessage: t('std_saving') });
};

const gql = `
    mutation AppointmentGraphqlMutation($datas: [JSONObject!]) {
        saveAppointment(data: { datas: $datas }) {
            id
        }
    }
`;
